// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Texte_full__1itQ7 {\n  width: 100%;\n  text-align: center;\n}\n.Texte_left__2yFI1 {\n  text-align: left;\n  margin-right: var(--landing-margin-texte);\n}\n.Texte_right__H4UFl {\n  text-align: right;\n  margin-left: var(--landing-margin-texte);\n}\n", "",{"version":3,"sources":["webpack://src/Landing/Includes/Texte.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C","sourcesContent":[".full {\n  width: 100%;\n  text-align: center;\n}\n.left {\n  text-align: left;\n  margin-right: var(--landing-margin-texte);\n}\n.right {\n  text-align: right;\n  margin-left: var(--landing-margin-texte);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"full": "Texte_full__1itQ7",
	"left": "Texte_left__2yFI1",
	"right": "Texte_right__H4UFl"
};
export default ___CSS_LOADER_EXPORT___;
